import { ui_log_entry } from "@/shared/dtos/logs/ui_log_entry";

export class ui_log_incident_group {
    public title!: string;
    public subtitle!: string;
    public count: number = 0;
    public lastOccurrence!: string;   // ISO string

    public logs: ui_log_entry[] = [];
    public exception: string | null = null;

    constructor(src?: any) {
        if (src) {
            Object.assign(this, src);
        }
    }
}
